exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-table {\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n.mat-header-cell, .mat-cell {\r\n    border: 1px solid #ccc;\r\n    padding: 8px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/member-logs/member-logs.component.css
// module id = 619
// module chunks = 0